<div *ngIf="isUserOwner && sharedWithUsers" class="d-flex flex-wrap justify-content-start">
    <div
        *ngFor="let user of sharedWithUsers.slice(0, 3); let i = index"
        class="picture-container picture-{{ i + 1 }}"
        [ngbTooltip]="user | fullName"
        data-uit="shared-with-users"
    >
        <label class="name-form font-s" type="text">
            <a *ngIf="user.picture" [routerLink]="['/user/profile', user.id]"><img class="profile-img" [src]="user.picture" /></a>
            <a *ngIf="!user.picture" class="initials font-s text-center" [routerLink]="['/user/profile', user.id]">
                {{ user | initials }}
            </a>
        </label>
    </div>
    <p *ngIf="sharedWithUsers.length > 3" class="ms-1 d-flex align-self-center">+ {{ sharedWithUsers.length - 3 }}</p>
</div>
<div *ngIf="!isUserOwner">
    <div class="d-flex picture-container" *ngIf="ownerInfo$ | async as ownerInfo" data-uit="shared-with-shared-by">
        <div class="me-1 align-self-center">
            {{ 'MY_WORKSPACE.MY_RESULTS.SHARING.ROW_SHARED_BY' | translate }}
        </div>
        <div [ngbTooltip]="ownerInfo | fullName">
            <label class="name-form font-s" type="text">
                <a *ngIf="ownerInfo?.picture" [routerLink]="['/user/profile', ownerId]"><img class="profile-img" [src]="ownerInfo?.picture" /></a>
                <a *ngIf="!ownerInfo?.picture" class="initials font-s text-center ms-1" [routerLink]="['/user/profile', ownerId]">
                    {{ ownerInfo | initials }}
                </a>
            </label>
        </div>
    </div>
</div>
